import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { 
  FaHome, 
  FaUser, 
  FaPlus, 
  FaFire, 
  FaHeadphones, 
  FaMusic, 
  FaSearch,
  FaNewspaper 
} from 'react-icons/fa';
import { Icon } from '../common/Icon';

const SidebarContainer = styled.aside<{ $isOpen: boolean }>`
  width: 200px;
  background-color: rgb(31, 31, 31);
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 4rem;
  left: 0;
  bottom: 0;
  z-index: 900;
    transform: translateX(${props => props.$isOpen ? '0' : '-100%'});
    transition: transform 0.3s ease-in-out;

  @media (min-width: 769px) {
    transform: translateX(0);
    top: 0;
    margin-top: 4rem;
  }
`;

const Nav = styled.nav`
  padding: 1.5rem 1rem 1rem 1rem;
`;

const NavItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.2s;
  margin-bottom: 0.5rem;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  &.active {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;
  
const NavText = styled.span`
  font-size: 1rem;
`;

interface SidebarProps {
  isOpen: boolean;
  onItemClick: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onItemClick }) => {
  const handleItemClick = () => {
    // Only close sidebar on mobile
    if (window.innerWidth <= 768) {
      // Small delay to allow navigation to complete first
      setTimeout(onItemClick, 10);
    }
  };

  return (
    <SidebarContainer $isOpen={isOpen}>
      <Nav>
        <NavItem to="/" onClick={handleItemClick}>
          <Icon icon={FaHome} size={20} />
          <NavText>Home</NavText>
        </NavItem>
        <NavItem to="/you" onClick={handleItemClick}>
          <Icon icon={FaUser} size={20} />
          <NavText>You</NavText>
        </NavItem>
                  <NavItem to="/create?new=true" onClick={handleItemClick}>
          <Icon icon={FaPlus} size={20} />
          <NavText>Create</NavText>
        </NavItem>
        <NavItem to="/popular" onClick={handleItemClick}>
          <Icon icon={FaFire} size={20} />
          <NavText>Popular</NavText>
        </NavItem>
        <NavItem to="/guided" onClick={handleItemClick}>
          <Icon icon={FaHeadphones} size={20} />
          <NavText>Guided</NavText>
        </NavItem>
        <NavItem to="/unguided" onClick={handleItemClick}>
          <Icon icon={FaMusic} size={20} />
          <NavText>Unguided</NavText>
        </NavItem>
        <NavItem to="/blog" onClick={handleItemClick}>
          <Icon icon={FaNewspaper} size={20} />
          <NavText>Blog</NavText>
        </NavItem>
        <NavItem to="/search" onClick={handleItemClick}>
          <Icon icon={FaSearch} size={20} />
          <NavText>Search</NavText>
          </NavItem>
      </Nav>
    </SidebarContainer>
  );
};

export default Sidebar; 